import { AsyncPipe, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { Observable, Subject, tap } from 'rxjs';
import { CsvSchema } from '../../../models/cutting/csv-schema.model';
import { CuttingPanelListService } from '../cutting-panel-list.service';

@Component({
  selector: 'csl-csv-schema-selector-dialog',
  templateUrl: 'csv-schema-selector-dialog.component.html',
  standalone: true,
  imports: [
    NgIf,
    NgFor,
    NgTemplateOutlet,
    AsyncPipe,
    MatSelectModule,
    MatButtonModule,
    MatFormFieldModule,
    MatDialogModule,
    MatIconModule,
    FormsModule,
  ],
})
export class CsvSchemaSelectorDialogComponent implements OnDestroy {
  csvSchemas$: Observable<CsvSchema[]>;
  selectedSchema: CsvSchema;

  unsubscribe$: Subject<void> = new Subject();

  constructor(private cuttingPanelListService: CuttingPanelListService) {
    this.getCsvSchemas();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }

  private getCsvSchemas(): void {
    this.csvSchemas$ = this.cuttingPanelListService.getCsvSchemas().pipe(tap(res => (this.selectedSchema = res[0])));
  }
}
